export default __webpack_public_path__ + "static/media/avatar_tommy1.0324ecd2.mp3";